/**
 * 共通スクリプト初期処理部
 *
 * 履歴：
 * No.    日付          更新者    更新内容
 *   1    2021/09/16            新規作成
 *
 * @summary 共通スクリプト初期処理部
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

import './_fin';
